// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addContainer {
  background: white;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 2px #aab2bd;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 0px 3px 2px #aab2bd;
}

.addH4 {
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 18px;
  font-family: inherit;
  font-weight: 500;
  color: inherit;
}

.queContainer {
  background-color: #f2f2f2;
  margin-left: 15%;
  margin-right: 15%;
}

.queH3 {
  font-size: 24px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  margin-top: 70px;
  margin-bottom: 20px;
  color: #797979;
}

.queH3 .queH3Arrow {
  font-size: 16px;
}

.queSubContainer {
  background-color: white;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 2px #aab2bd;
}

.queH4 {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: #797979;
}

.queContant {
  width: 75%;
  height: 480px;
  margin: 20px auto;
  margin-bottom: 30px;
}

.uploadedPDFDisplay {
  height: 660px;
}

.uploadedImageDisplay {
  height: 550px;
}

.queContant canvas {
  width: 100% !important;
  height: 700px !important;
}

.uploadedImage {
  width: 100% !important;
  height: 500px !important;
}

.quePage {
  text-align: center;
  font-weight: bold;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 15px;
  margin: 10px;
}

.queContainerButtons {
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.queAdd {
  background: #68dff0;
  color: white;
  padding: 5px 12px;
  margin-right: 16%;
  border-radius: 4px;
  border: 1px solid #64c3c2 !important;
}
.queAdd:hover {
  background: #51cac2;
}

.queArrowLeft {
  background: #68dff0;
  color: white;
  padding: 4px 2px 4px 10px;
  margin-right: 2%;
  border-radius: 4px;
  border: 1px solid #64c3c2 !important;
}
.queArrowLeft:disabled {
  cursor: not-allowed;
  background: #b7e8f0;
  border: 1px solid #b7e8f0 !important;
}

.queArrowRight {
  background: #68dff0;
  color: white;
  padding: 5px 7px;
  border: none;
  /* margin-right: 18%; */
  border-radius: 4px;
  border: 1px solid #64c3c2 !important;
}
.queArrowRight:disabled {
  cursor: not-allowed;
  background: #b7e8f0;
  border: 1px solid #b7e8f0 !important;
}

.queDelet {
  background: #f0ad4e;
  color: white;
  padding: 8px;
  border: none;
  margin-right: 0%;
  border-radius: 4px;
  border: 1px solid #eea236 !important;
}

.questionCopyHead {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  padding-right: 2%;
  width: 20%;
  padding-left: 8.2%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.questionCopyBtn {
  height: 32px;
  width: 52.2%;
  box-sizing: border-box;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 5.5%;
  margin-right: 8%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  cursor: pointer;
}

.questionCopyTextarea {
  height: 80px;
  padding: 10px;
  width: 52.2%;
  box-sizing: border-box;
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 5.5%;
  margin-right: 8%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
}

.compulsoryContainer {
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
  margin-left: 15%;
  margin-right: 15%;
}

.compulsoryHeading {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 20px;
  font-family: "Ruda", sans-serif;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

.compulsorySubContainer {
  display: flex;
  justify-content: left;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 5px;
}

.compulsoryDropdown {
  width: 100%;
  margin-bottom: 20px;
}

.moreContainer {
  background: #ffffff;
  padding: 14px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 2px #aab2bd;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 0px 3px 2px #aab2bd;
}

.moreH4 {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: "Ruda", sans-serif;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

.moreSubContainer {
  display: flex;
  justify-content: left;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 5px;
}

.moreDropdown {
  width: 100%;
  margin-bottom: 20px;
}

.moreCheckbox {
  margin-left: 20%;
}

.addLabel {
  display: block;
  margin-top: 10px;
  margin-bottom: 5px;
  font-size: 18px;
  font-family: inherit;
  font-weight: 500;
  color: inherit;
}

.addLabel::after {
  content: "*";
  color: #797979;
  margin-left: 2px;
}

.addLabelRed {
  display: block;
  margin-top: 10px;
  margin-bottom: 5px;
  font-size: 18px;
  font-family: inherit;
  font-weight: 500;
  color: red;
}

.addLabelRed::after {
  content: "*";
  color: red;
  margin-left: 2px;
}

.addInput {
  display: block;
  width: 98%;
  height: auto;
  outline-color: #68dff0;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding-bottom: 20px;
}

.addOpt {
  margin-bottom: 5px;
  margin-left: 8%;
}

.addFile {
  margin-bottom: 20px;
  color: #fff;
  background-color: #68dff0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-image: none;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
}

.addSubmit {
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
}
.addSubmit:hover {
  background-color: #51cac2;
}

.addSubmit:disabled {
  background-color: #acafaf;
  cursor: not-allowed;
  border: none;
}

.addInputSmall {
  height: 32px;
  width: 52%;
  box-sizing: border-box;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.addInputFile {
  max-height: 22px;
  width: 36.8%;
  margin-left: 4%;
  margin-right: 4%;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
}

.css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
  height: 32px;
  width: 52.4%;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4% !important;
  margin-right: 11% !important;
  border-radius: 4px;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 6px !important;
}

.uploadButton {
  max-height: 36px;
  width: 8.2%;
  color: #f2f2f2;
  font-size: 14px;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  border: 1px solid #64c3c2 !important;
  padding: 8px 0.5%;
  background: #68dff0;
  cursor: pointer;
  margin-right: 11%;
}

.shortDescription {
  margin-left: 9%;
  margin-right: 9%;
  width: 77.5%;
  margin-bottom: 20px;
}

.sun-editor {
  width: 68.5% !important;
  display: block !important;
  margin-left: 207px !important;
}

.modal_close {
  margin-left: 82% !important;
  margin-top: 30px !important;
}

.editorBtn {
  height: 32px;
  width: 52.4%;
  box-sizing: border-box;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  cursor: pointer;
}

.editorBtn:hover {
  background-color: rgb(202, 200, 200);
}

.editorBtn:active {
  border: 2px solid #555;
}

.contentText {
  height: auto;
  width: auto;
  margin: 15px;
  background-color: #f7f3f3;
  padding: 6px;
  margin-left: 8%;
  margin-right: 12%;
  font-size: 11px;
  border-radius: 10px;
}

.addCheckbox {
  height: 22px;
  width: 3.2%;
  box-sizing: border-box;
  position: relative;
  max-height: 35px;
  margin-left: 4%;
  margin-right: 11%;
}

.fileChooseRespone {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  font-family: "Ruda", sans-serif;
  margin-left: 4%;
  margin-right: 11%;
  margin-top: 3px;
  border-radius: 4px;
  outline-color: #68dff0;
  margin-bottom: 5px;
  color: #fff;
  background-color: #68dff0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-image: none;
  border: 1px solid #48bcb4;
  padding: 6px 12px;
  cursor: pointer;
}

.btnDivMatching {
  display: flex;
  justify-content: center;
}

.btnResponse {
  border-radius: 50%;
  color: #f2f2f2;
  font-size: 24px;
  border: none;
  padding: 2px 12px;
  margin-right: 15px;
  background: #68dff0;
  margin-top: 15px;
  cursor: pointer;
}
.btnResponse:hover {
  background-color: #51cac2;
}

.btnResponse:active {
  border: 1px solid #03afa9 !important;
}

.btnResponseMinus {
  border-radius: 50%;
  color: #f2f2f2;
  border: none;
  font-size: 30px;
  padding: 3px 14px;
  margin-right: 15px;
  background: #68dff0;
  margin-top: 15px;
  cursor: pointer;
}
.btnResponseMinus:hover {
  background-color: #51cac2;
}

.btnResponseMinus:active {
  border: 1px solid #03afa9 !important;
}

.btnFilesUpload {
  color: #f2f2f2;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  padding: 8px 15px;
  margin-right: 15px;
  background: #68dff0;
  cursor: pointer;
  max-height: 35px;
  margin-top: 3px;
}
.btnFilesUpload:hover {
  background-color: #51cac2;
}

.btnFilesUpload:active {
  border: 1px solid #03afa9 !important;
}

.searchQuestionLabelMat {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  margin-left: 2%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.fileChooseAddDetails {
  box-sizing: border-box;
  width: 41%;
  position: relative;
  max-height: 35px;
  font-family: "Ruda", sans-serif;
  margin-left: 5.5%;
  margin-right: 2.5%;
  border-radius: 4px;
  outline-color: #68dff0;
  color: #fff;
  background-color: #68dff0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid #48bcb4;
  padding: 6px 12px;
  cursor: pointer;
}

.btnFilesUploadAddDetails {
  color: #f2f2f2;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  padding: 8px 15px;
  margin-right: 88px;
  background: #68dff0;
  cursor: pointer;
  max-height: 35px;
}
.btnFilesUploadAddDetails:hover {
  background-color: #51cac2;
}

.btnFilesUploadAddDetails:active {
  border: 1px solid #03afa9 !important;
}

.dropdownLabelHint {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  margin-left: 9%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.solutionDropdownDiv {
  display: flex;
  margin: 30px 0 30px 0;
}

.solutionCopyHead {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  padding-right: 2%;
  width: 20%;
  padding-left: 9%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.searchQuestionSelectText {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  height: 80px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.addLabelDescripton {
  display: block;
  margin-top: 10px;
  margin-bottom: 5px;
  font-size: 18px;
  font-family: inherit;
  font-weight: 500;
  color: inherit;
}

.compulsoryContainerMAQ {
  width: 30%;
  margin-left: 35%;
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
  margin-right: 15%;
}

.searchQuestionLabelMAQ {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.fileCopyUploaded {
  margin-top: -10px;
  margin-left: 36%;
  font-size: 12px;
  color: #797979;
  font-family: "Ruda", sans-serif;
}
.fileCopyUploadedSpin {
  height: 25px !important;
  width: 25px !important;
  margin-top: -10px;
  margin-left: 36%;
}

.fileCopyUploadedText {
  margin-left: 40%;
  margin-top: -17px;
  font-size: 12px;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.fileSolUploaded {
  margin-top: -22px;
  margin-left: 37%;
  font-size: 12px;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.fileSolUploadedSpin {
  height: 25px !important;
  width: 25px !important;
  margin-top: -20px;
  margin-left: 38%;
}

.fileSolUploadedText {
  margin-left: 42%;
  margin-top: -20px;
  font-size: 12px;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.fileImageUploaded {
  margin-top: 2px;
  margin-left: 33%;
  font-size: 12px;
  color: #797979;
  font-family: "Ruda", sans-serif;
}
.fileResUploadedSpin {
  height: 25px !important;
  width: 25px !important;
  margin-top: 0px;
  margin-left: 33%;
}

.fileResUploadedText {
  margin-left: 39%;
  margin-top: -18px;
  font-size: 12px;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.AddDetailsLoadingDiv {
  display: inline-flex;
  height: 30px;
  width: 290px;
}

.addDetailsLoadingDivErr {
  display: inline-flex;
  height: 30px;
  width: 800px;
}

.loadingDivErr {
  display: inline-flex;
  height: 30px;
  position: absolute;
  width: 800px;
}

.loadingTextDataErr {
  width: auto;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 4%;
  margin-left: 15px;
}

.startLoadSpin {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 150px !important;
  margin-left: -100px;
  height: 50px;
  margin-top: -25px;
  z-index: 100;
}

.loadingBackground {
  position: fixed; /* Positioning and size */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 99;
}

.compulsoryContainerCheckboxSubmit {
  display: flex;
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
  margin-left: 15%;
  margin-right: 15%;
}

.addDetailsCuratedDiv {
  display: flex;
  margin-right: 30px;
}

.addDetailsCuratedP {
  margin: 8px 0px 0px 10px;
  font-size: 16px;
  font-weight: 500;
}

.addReject {
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 9%;
}

.curatedWarning {
  /* position: sticky;
  top: 61px;
  padding: 0px 37%;
  width: 100%;
  background: #e50808;
  margin-left: -8px;
  z-index: 10; */

  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 61px;
  width: 100%;
  background: #e50808;
  z-index: 10;
  min-height: 40px;
}

.curatedWarningP {
  font-weight: 600;
}

.docxFileDiv {
  width: 75%;
  margin: 15px auto;
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
  margin-bottom: 30px;
  border: 2px solid #d9d2d2;
  border-radius: 5px;
}

.pg-viewer-wrapper {
  width: 103%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/AddDetails/addDetails.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;EACxE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;EACxE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe,EAAE,yBAAyB;EAC1C,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;;;;;;gBAMc;;EAEd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".addContainer {\n  background: white;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-shadow: 0px 3px 2px #aab2bd;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 0px 3px 2px #aab2bd;\n}\n\n.addH4 {\n  margin-top: 5px;\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-family: inherit;\n  font-weight: 500;\n  color: inherit;\n}\n\n.queContainer {\n  background-color: #f2f2f2;\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.queH3 {\n  font-size: 24px;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n  margin-top: 70px;\n  margin-bottom: 20px;\n  color: #797979;\n}\n\n.queH3 .queH3Arrow {\n  font-size: 16px;\n}\n\n.queSubContainer {\n  background-color: white;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-shadow: 0px 3px 2px #aab2bd;\n}\n\n.queH4 {\n  font-size: 18px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: #797979;\n}\n\n.queContant {\n  width: 75%;\n  height: 480px;\n  margin: 20px auto;\n  margin-bottom: 30px;\n}\n\n.uploadedPDFDisplay {\n  height: 660px;\n}\n\n.uploadedImageDisplay {\n  height: 550px;\n}\n\n.queContant canvas {\n  width: 100% !important;\n  height: 700px !important;\n}\n\n.uploadedImage {\n  width: 100% !important;\n  height: 500px !important;\n}\n\n.quePage {\n  text-align: center;\n  font-weight: bold;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 15px;\n  margin: 10px;\n}\n\n.queContainerButtons {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n}\n\n.queAdd {\n  background: #68dff0;\n  color: white;\n  padding: 5px 12px;\n  margin-right: 16%;\n  border-radius: 4px;\n  border: 1px solid #64c3c2 !important;\n}\n.queAdd:hover {\n  background: #51cac2;\n}\n\n.queArrowLeft {\n  background: #68dff0;\n  color: white;\n  padding: 4px 2px 4px 10px;\n  margin-right: 2%;\n  border-radius: 4px;\n  border: 1px solid #64c3c2 !important;\n}\n.queArrowLeft:disabled {\n  cursor: not-allowed;\n  background: #b7e8f0;\n  border: 1px solid #b7e8f0 !important;\n}\n\n.queArrowRight {\n  background: #68dff0;\n  color: white;\n  padding: 5px 7px;\n  border: none;\n  /* margin-right: 18%; */\n  border-radius: 4px;\n  border: 1px solid #64c3c2 !important;\n}\n.queArrowRight:disabled {\n  cursor: not-allowed;\n  background: #b7e8f0;\n  border: 1px solid #b7e8f0 !important;\n}\n\n.queDelet {\n  background: #f0ad4e;\n  color: white;\n  padding: 8px;\n  border: none;\n  margin-right: 0%;\n  border-radius: 4px;\n  border: 1px solid #eea236 !important;\n}\n\n.questionCopyHead {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  padding-right: 2%;\n  width: 20%;\n  padding-left: 8.2%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.questionCopyBtn {\n  height: 32px;\n  width: 52.2%;\n  box-sizing: border-box;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 5.5%;\n  margin-right: 8%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  cursor: pointer;\n}\n\n.questionCopyTextarea {\n  height: 80px;\n  padding: 10px;\n  width: 52.2%;\n  box-sizing: border-box;\n  position: relative;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 5.5%;\n  margin-right: 8%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n}\n\n.compulsoryContainer {\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.compulsoryHeading {\n  font-size: 18px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  font-family: \"Ruda\", sans-serif;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\n\n.compulsorySubContainer {\n  display: flex;\n  justify-content: left;\n  flex-direction: row;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.compulsoryDropdown {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.moreContainer {\n  background: #ffffff;\n  padding: 14px;\n  margin-bottom: 15px;\n  box-shadow: 0px 3px 2px #aab2bd;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 0px 3px 2px #aab2bd;\n}\n\n.moreH4 {\n  font-size: 18px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-family: \"Ruda\", sans-serif;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\n\n.moreSubContainer {\n  display: flex;\n  justify-content: left;\n  flex-direction: row;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.moreDropdown {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.moreCheckbox {\n  margin-left: 20%;\n}\n\n.addLabel {\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  font-size: 18px;\n  font-family: inherit;\n  font-weight: 500;\n  color: inherit;\n}\n\n.addLabel::after {\n  content: \"*\";\n  color: #797979;\n  margin-left: 2px;\n}\n\n.addLabelRed {\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  font-size: 18px;\n  font-family: inherit;\n  font-weight: 500;\n  color: red;\n}\n\n.addLabelRed::after {\n  content: \"*\";\n  color: red;\n  margin-left: 2px;\n}\n\n.addInput {\n  display: block;\n  width: 98%;\n  height: auto;\n  outline-color: #68dff0;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding-bottom: 20px;\n}\n\n.addOpt {\n  margin-bottom: 5px;\n  margin-left: 8%;\n}\n\n.addFile {\n  margin-bottom: 20px;\n  color: #fff;\n  background-color: #68dff0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.addSubmit {\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.addSubmit:hover {\n  background-color: #51cac2;\n}\n\n.addSubmit:disabled {\n  background-color: #acafaf;\n  cursor: not-allowed;\n  border: none;\n}\n\n.addInputSmall {\n  height: 32px;\n  width: 52%;\n  box-sizing: border-box;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.addInputFile {\n  max-height: 22px;\n  width: 36.8%;\n  margin-left: 4%;\n  margin-right: 4%;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.css-1u3bzj6-MuiFormControl-root-MuiTextField-root {\n  height: 32px;\n  width: 52.4%;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4% !important;\n  margin-right: 11% !important;\n  border-radius: 4px;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 6px !important;\n}\n\n.uploadButton {\n  max-height: 36px;\n  width: 8.2%;\n  color: #f2f2f2;\n  font-size: 14px;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  border: 1px solid #64c3c2 !important;\n  padding: 8px 0.5%;\n  background: #68dff0;\n  cursor: pointer;\n  margin-right: 11%;\n}\n\n.shortDescription {\n  margin-left: 9%;\n  margin-right: 9%;\n  width: 77.5%;\n  margin-bottom: 20px;\n}\n\n.sun-editor {\n  width: 68.5% !important;\n  display: block !important;\n  margin-left: 207px !important;\n}\n\n.modal_close {\n  margin-left: 82% !important;\n  margin-top: 30px !important;\n}\n\n.editorBtn {\n  height: 32px;\n  width: 52.4%;\n  box-sizing: border-box;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  cursor: pointer;\n}\n\n.editorBtn:hover {\n  background-color: rgb(202, 200, 200);\n}\n\n.editorBtn:active {\n  border: 2px solid #555;\n}\n\n.contentText {\n  height: auto;\n  width: auto;\n  margin: 15px;\n  background-color: #f7f3f3;\n  padding: 6px;\n  margin-left: 8%;\n  margin-right: 12%;\n  font-size: 11px;\n  border-radius: 10px;\n}\n\n.addCheckbox {\n  height: 22px;\n  width: 3.2%;\n  box-sizing: border-box;\n  position: relative;\n  max-height: 35px;\n  margin-left: 4%;\n  margin-right: 11%;\n}\n\n.fileChooseRespone {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  font-family: \"Ruda\", sans-serif;\n  margin-left: 4%;\n  margin-right: 11%;\n  margin-top: 3px;\n  border-radius: 4px;\n  outline-color: #68dff0;\n  margin-bottom: 5px;\n  color: #fff;\n  background-color: #68dff0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #48bcb4;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.btnDivMatching {\n  display: flex;\n  justify-content: center;\n}\n\n.btnResponse {\n  border-radius: 50%;\n  color: #f2f2f2;\n  font-size: 24px;\n  border: none;\n  padding: 2px 12px;\n  margin-right: 15px;\n  background: #68dff0;\n  margin-top: 15px;\n  cursor: pointer;\n}\n.btnResponse:hover {\n  background-color: #51cac2;\n}\n\n.btnResponse:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.btnResponseMinus {\n  border-radius: 50%;\n  color: #f2f2f2;\n  border: none;\n  font-size: 30px;\n  padding: 3px 14px;\n  margin-right: 15px;\n  background: #68dff0;\n  margin-top: 15px;\n  cursor: pointer;\n}\n.btnResponseMinus:hover {\n  background-color: #51cac2;\n}\n\n.btnResponseMinus:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.btnFilesUpload {\n  color: #f2f2f2;\n  font-size: 14px;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 15px;\n  margin-right: 15px;\n  background: #68dff0;\n  cursor: pointer;\n  max-height: 35px;\n  margin-top: 3px;\n}\n.btnFilesUpload:hover {\n  background-color: #51cac2;\n}\n\n.btnFilesUpload:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.searchQuestionLabelMat {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  margin-left: 2%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.fileChooseAddDetails {\n  box-sizing: border-box;\n  width: 41%;\n  position: relative;\n  max-height: 35px;\n  font-family: \"Ruda\", sans-serif;\n  margin-left: 5.5%;\n  margin-right: 2.5%;\n  border-radius: 4px;\n  outline-color: #68dff0;\n  color: #fff;\n  background-color: #68dff0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #48bcb4;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.btnFilesUploadAddDetails {\n  color: #f2f2f2;\n  font-size: 14px;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 15px;\n  margin-right: 88px;\n  background: #68dff0;\n  cursor: pointer;\n  max-height: 35px;\n}\n.btnFilesUploadAddDetails:hover {\n  background-color: #51cac2;\n}\n\n.btnFilesUploadAddDetails:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.dropdownLabelHint {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  margin-left: 9%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.solutionDropdownDiv {\n  display: flex;\n  margin: 30px 0 30px 0;\n}\n\n.solutionCopyHead {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  padding-right: 2%;\n  width: 20%;\n  padding-left: 9%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.searchQuestionSelectText {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  height: 80px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.addLabelDescripton {\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  font-size: 18px;\n  font-family: inherit;\n  font-weight: 500;\n  color: inherit;\n}\n\n.compulsoryContainerMAQ {\n  width: 30%;\n  margin-left: 35%;\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n  margin-right: 15%;\n}\n\n.searchQuestionLabelMAQ {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.fileCopyUploaded {\n  margin-top: -10px;\n  margin-left: 36%;\n  font-size: 12px;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n.fileCopyUploadedSpin {\n  height: 25px !important;\n  width: 25px !important;\n  margin-top: -10px;\n  margin-left: 36%;\n}\n\n.fileCopyUploadedText {\n  margin-left: 40%;\n  margin-top: -17px;\n  font-size: 12px;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.fileSolUploaded {\n  margin-top: -22px;\n  margin-left: 37%;\n  font-size: 12px;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.fileSolUploadedSpin {\n  height: 25px !important;\n  width: 25px !important;\n  margin-top: -20px;\n  margin-left: 38%;\n}\n\n.fileSolUploadedText {\n  margin-left: 42%;\n  margin-top: -20px;\n  font-size: 12px;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.fileImageUploaded {\n  margin-top: 2px;\n  margin-left: 33%;\n  font-size: 12px;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n.fileResUploadedSpin {\n  height: 25px !important;\n  width: 25px !important;\n  margin-top: 0px;\n  margin-left: 33%;\n}\n\n.fileResUploadedText {\n  margin-left: 39%;\n  margin-top: -18px;\n  font-size: 12px;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.AddDetailsLoadingDiv {\n  display: inline-flex;\n  height: 30px;\n  width: 290px;\n}\n\n.addDetailsLoadingDivErr {\n  display: inline-flex;\n  height: 30px;\n  width: 800px;\n}\n\n.loadingDivErr {\n  display: inline-flex;\n  height: 30px;\n  position: absolute;\n  width: 800px;\n}\n\n.loadingTextDataErr {\n  width: auto;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 4%;\n  margin-left: 15px;\n}\n\n.startLoadSpin {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 150px !important;\n  margin-left: -100px;\n  height: 50px;\n  margin-top: -25px;\n  z-index: 100;\n}\n\n.loadingBackground {\n  position: fixed; /* Positioning and size */\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(128, 128, 128, 0.5);\n  z-index: 99;\n}\n\n.compulsoryContainerCheckboxSubmit {\n  display: flex;\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.addDetailsCuratedDiv {\n  display: flex;\n  margin-right: 30px;\n}\n\n.addDetailsCuratedP {\n  margin: 8px 0px 0px 10px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.addReject {\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 9%;\n}\n\n.curatedWarning {\n  /* position: sticky;\n  top: 61px;\n  padding: 0px 37%;\n  width: 100%;\n  background: #e50808;\n  margin-left: -8px;\n  z-index: 10; */\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: sticky;\n  top: 61px;\n  width: 100%;\n  background: #e50808;\n  z-index: 10;\n  min-height: 40px;\n}\n\n.curatedWarningP {\n  font-weight: 600;\n}\n\n.docxFileDiv {\n  width: 75%;\n  margin: 15px auto;\n  max-height: 450px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: auto;\n  margin-bottom: 30px;\n  border: 2px solid #d9d2d2;\n  border-radius: 5px;\n}\n\n.pg-viewer-wrapper {\n  width: 103%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
